import { useCallback as n, useEffect as o } from "react";
const u = (e, t) => {
  const c = n(() => {
    if (e?.current) {
      const r = e.current.getBoundingClientRect();
      t(r.height);
    }
  }, [e, t]);
  o(() => {
    if (!e?.current) return;
    const r = new ResizeObserver(() => {
      c();
    });
    return r.observe(e.current), () => r.disconnect();
  }, [e, c]);
};
export {
  u as useTextInputResizeObserver
};
